import { DateTime } from 'luxon';
import { ZONE } from '@web/common';
import type {
  ParticipantNachversandResDto,
  Part2NachversandState,
} from '@web/common';

// after this, a missed call is only offered for re-booking in the "Versand" tab
export const MISSED_HINT_DAYS = 7;

// The home banner only shows when there is something to do: a booked call, or a missed one that
// ended at most seven days ago. Not eligible means no current cycle, so nothing either.
export function getNachversandHomeBannerState(
  nachversand: ParticipantNachversandResDto | null,
  now: DateTime = DateTime.now(),
): Part2NachversandState | null {
  const current = nachversand?.current ?? null;
  if (current === null) {
    return null;
  }
  if (current.state === 'BOOKED') {
    return 'BOOKED';
  }

  const hintShownUntil = DateTime.fromJSDate(current.appointment.endTime, {
    zone: ZONE,
  }).plus({ days: MISSED_HINT_DAYS });
  return now <= hintShownUntil ? 'MISSED' : null;
}
